<div class="card card-custom example example-compact gutter-b" *ngIf="viewItem">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ viewItem.beforeCodeTitle }}</h3>
    </div>
    <div class="card-toolbar">
      <div class="example-tools justify-content-center">
        <span class="example-toggle" ngbTooltip="View code"></span>
        <span class="example-copy" ngbTooltip="Copy code"></span>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div>
      <!--begin::Code example-->
      <div class="example-code mb-5">
        <ul ktTabClickEvent class="example-nav nav nav-tabs nav-bold nav-tabs-line nav-tabs-line-2x" role="tablist">
          <li class="nav-item" *ngIf="viewItem.htmlCode">
            <a (click)="tab.select('tab-id-1')" class="nav-link active" data-toggle="tab" href="javascript:;"
              role="tab">HTML</a>
          </li>
          <li class="nav-item" *ngIf="viewItem.tsCode">
            <a (click)="tab.select('tab-id-2')" class="nav-link" data-toggle="tab" href="javascript:;" role="tab">TS</a>
          </li>
          <li class="nav-item" *ngIf="viewItem.cssCode">
            <a (click)="tab.select('tab-id-3')" class="nav-link" data-toggle="tab" href="javascript:;"
              role="tab">CSS</a>
          </li>
          <li class="nav-item" *ngIf="viewItem.scssCode">
            <a (click)="tab.select('tab-id-4')" class="nav-link" data-toggle="tab" href="javascript:;"
              role="tab">SCSS</a>
          </li>
        </ul>
        <div ngbNav #nav="ngbNav" class="nav-tabs">
          <ng-container ngbNavItem="tab-id-1" *ngIf="viewItem.htmlCode">
            <ng-template ngbNavContent>
              <div class="example-highlight">
                <pre><code [highlight]="viewItem.htmlCode"></code></pre>
              </div>
            </ng-template>
          </ng-container>
          <ng-container ngbNavItem="tab-id-2" *ngIf="viewItem.tsCode">
            <ng-template ngbNavContent>
              <div class="example-highlight">
                <pre><code [highlight]="viewItem.tsCode"></code></pre>
              </div>
            </ng-template>
          </ng-container>
          <ng-container ngbNavItem="tab-id-3" *ngIf="viewItem.cssCode">
            <ng-template ngbNavContent>
              <div class="example-highlight">
                <pre><code [highlight]="viewItem.cssCode"></code></pre>
              </div>
            </ng-template>
          </ng-container>
          <ng-container ngbNavItem="tab-id-4" *ngIf="viewItem.scssCode">
            <ng-template ngbNavContent>
              <div class="example-highlight">
                <pre><code [highlight]="viewItem.scssCode"></code></pre>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <!--end::Code example-->

      <!-- view -->
      <ng-content></ng-content>
      <!-- / view -->

      <!-- after Code Title -->
      <div *ngIf="viewItem.afterCodeTitle" class="kt-portlet__preview"
        [innerHTML]="viewItem.afterCodeTitle | safe: 'html'">
      </div>
      <!-- / after Code Title -->

      <!-- after Code Description -->
      <div *ngIf="viewItem.afterCodeDescription" class="kt-portlet__preview"
        [innerHTML]="viewItem.afterCodeDescription | safe: 'html'">
      </div>
    </div>
  </div>
</div>
